/*
 *   Module Loader - SSEN Distribution
 *   Consumes an array of .js-modules and parses data-module attribute to produce an array
 *   of module names to be loaded.
 *
 *   Markup must include class="js-module" and
 *   data-module="['my-module-1', 'my-module-2'"]
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { camelize } from '@/scripts/lib/camelize';
var PL_DEBUG = window.plDebug || false;
function load(key) {
    var _this = this;
    var modules = {
        // Accordion
        accordion: function () { return __awaiter(_this, void 0, void 0, function () {
            var accordion;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/accordion/mando-ui.accordion')];
                    case 1:
                        accordion = (_a.sent()).default;
                        accordion();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Active Network Management Graph
        anmGraph: function () { return __awaiter(_this, void 0, void 0, function () {
            var anmGraph;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/active-network-management-graph/active-network-management-graph')];
                    case 1:
                        anmGraph = (_a.sent()).default;
                        anmGraph();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Active Network Management Table
        anmTable: function () { return __awaiter(_this, void 0, void 0, function () {
            var anmTable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/active-network-management-table/active-network-management-table')];
                    case 1:
                        anmTable = (_a.sent()).default;
                        anmTable();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Banner Notification
        bannerNotification: function () { return __awaiter(_this, void 0, void 0, function () {
            var bannerNotification;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/banner-notification/mando-ui.banner-notification')];
                    case 1:
                        bannerNotification = (_a.sent()).default;
                        bannerNotification();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Distributor Search
        distributorSearch: function () { return __awaiter(_this, void 0, void 0, function () {
            var distributorSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/distributor-search/mando-ui.distributor-search')];
                    case 1:
                        distributorSearch = (_a.sent()).default;
                        distributorSearch();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Floating CTA banner
        floatingCtaBanner: function () { return __awaiter(_this, void 0, void 0, function () {
            var floatingCtaBanner;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/floating-cta-banner/mando-ui.floating-cta-banner')];
                    case 1:
                        floatingCtaBanner = (_a.sent()).default;
                        floatingCtaBanner();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // icon block
        iconBlock: function () { return __awaiter(_this, void 0, void 0, function () {
            var iconBlock;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/icon-block/mando-ui.icon-block')];
                    case 1:
                        iconBlock = (_a.sent()).default;
                        iconBlock();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // iFrame
        iframe: function () { return __awaiter(_this, void 0, void 0, function () {
            var iframe;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/iframe/mando-ui.iframe')];
                    case 1:
                        iframe = (_a.sent()).default;
                        iframe();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Nav
        nav: function () { return __awaiter(_this, void 0, void 0, function () {
            var nav;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/subcomponents/header/_nav/mando-ui.nav')];
                    case 1:
                        nav = (_a.sent()).default;
                        nav();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // News Filter
        newsFilter: function () { return __awaiter(_this, void 0, void 0, function () {
            var newsFilter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/news-filter/mando-ui.news-filter')];
                    case 1:
                        newsFilter = (_a.sent()).default;
                        newsFilter();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // On Demand Calculator
        onDemandCalculator: function () { return __awaiter(_this, void 0, void 0, function () {
            var onDemandCalculator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/on-demand-calculator/on-demand-calculator')];
                    case 1:
                        onDemandCalculator = (_a.sent()).default;
                        onDemandCalculator();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Priority Services Register
        priorityServicesRegister: function () { return __awaiter(_this, void 0, void 0, function () {
            var priorityServicesRegister;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/priority-services-register/priority-services-register')];
                    case 1:
                        priorityServicesRegister = (_a.sent()).default;
                        priorityServicesRegister();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Quick Estimate Calculator
        quickEstimateCalculator: function () { return __awaiter(_this, void 0, void 0, function () {
            var quickEstimateCalculator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/quick-estimate-calculator/quick-estimate-calculator')];
                    case 1:
                        quickEstimateCalculator = (_a.sent()).default;
                        quickEstimateCalculator();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // RTE Table
        rteTable: function () { return __awaiter(_this, void 0, void 0, function () {
            var rteTable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/subcomponents/_rte-table/mando-ui.rte-table')];
                    case 1:
                        rteTable = (_a.sent()).default;
                        rteTable();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Searchbar
        searchbar: function () { return __awaiter(_this, void 0, void 0, function () {
            var searchbar;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/subcomponents/header/_searchbar/mando-ui.searchbar')];
                    case 1:
                        searchbar = (_a.sent()).default;
                        searchbar();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Search Results Filter
        searchResultsFilter: function () { return __awaiter(_this, void 0, void 0, function () {
            var searchResultsFilter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/search-results-filter/mando-ui.search-results-filter')];
                    case 1:
                        searchResultsFilter = (_a.sent()).default;
                        searchResultsFilter();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Supplier Search
        supplierSearch: function () { return __awaiter(_this, void 0, void 0, function () {
            var supplierSearch;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/supplier-search/supplier-search')];
                    case 1:
                        supplierSearch = (_a.sent()).default;
                        supplierSearch();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // triageTabs
        triage: function () { return __awaiter(_this, void 0, void 0, function () {
            var triage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/_triage/mando-ui.triage')];
                    case 1:
                        triage = (_a.sent()).default;
                        triage();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Recite Me
        reciteMe: function () { return __awaiter(_this, void 0, void 0, function () {
            var reciteMe;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/templates/02-components/recite-me/mando-ui.recite-me')];
                    case 1:
                        reciteMe = (_a.sent()).default;
                        reciteMe();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Alternate Provider Registration Form
        alternateProviderRegistrationForm: function () { return __awaiter(_this, void 0, void 0, function () {
            var alternateProviderRegistrationForm;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/alternate-provider-registration-form/alternate-provider-registration-form')];
                    case 1:
                        alternateProviderRegistrationForm = (_a.sent()).default;
                        alternateProviderRegistrationForm();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        // Alternate Provider Results
        alternateProviderResults: function () { return __awaiter(_this, void 0, void 0, function () {
            var alternateProviderResults;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import('@/app/views/alternate-provider-results/alternate-provider-results')];
                    case 1:
                        alternateProviderResults = (_a.sent()).default;
                        alternateProviderResults();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
        meterSerialNumber: function () { return __awaiter(_this, void 0, void 0, function () {
            var meterSerialNumber;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, import("@/app/views/meter-serial-number/meter-serial-number")];
                    case 1:
                        meterSerialNumber = (_a.sent()).default;
                        meterSerialNumber();
                        if (PL_DEBUG)
                            console.log("%c".concat(key, " loaded"), 'color: #000; background: yellow;');
                        return [2 /*return*/];
                }
            });
        }); },
    };
    try {
        return modules[key]();
    }
    catch (e) {
        console.warn("Module ".concat(key, " not found."));
    }
}
function init(modules) {
    if (!modules)
        return;
    var moduleList = [];
    modules.forEach(function (element) {
        try {
            var moduleNames = element.dataset.module;
            if (moduleNames) {
                var moduleArray = JSON.parse(moduleNames.replace(/'/g, '"'));
                moduleArray.forEach(function (item) {
                    var module = camelize(item);
                    if (moduleList.indexOf(module) === -1)
                        moduleList.push(module);
                });
            }
        }
        catch (e) {
            console.error('JS name format incorrect in data attribute:');
            console.log(moduleList);
        }
    });
    moduleList.forEach(function (module) { return load(module); });
}
export default init;
